'use client'

import { AdResponse } from '@/app/util/ads-endpoint'
import { Banner } from '@/app/util/banner'
import { createContext } from 'react'

export type AdsContextProps = {
    isAnyAdEnabled: () => boolean
    pageName?: string
    adClientData?: AdResponse
    adServerData?: AdResponse
    banner?: Banner
    hasTopLeaderboardAd?: boolean
}

const AdsContext = createContext({
    banner: undefined,
    isAnyAdEnabled: () => false,
    pageName: undefined,
    adClientData: undefined,
    adServerData: undefined,
} as AdsContextProps)

export default AdsContext
